module.exports = __webpack_public_path__ + "static/img/business1.6711472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/business1.jpg
// module id = 163
// module chunks = 1